export default __webpack_public_path__ + "static/media/DASH-dark.18d4837a.svg";